var _templateObject;
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
import styled from "styled-components";
export var Container = styled.div.attrs({
  "data-mesh-component": "CONTAINER"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  max-width: ", ";\n  margin-right: auto;\n  margin-left: auto;\n  box-sizing: border-box;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.container && theme.container.width || "75rem";
});
Container.displayName = "Container";